module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"menu":{"buyNow":"ZAMÓW","positions":{"offer":"Oferta","about":"O firmie","faq":"FAQ","work":"Praca","news":"Aktualności","contact":"Kontakt"},"buyOnline":"Zamów online"}},"en":{"menu":{"buyNow":"ORDER","positions":{"offer":"Offer","about":"About the company","faq":"FAQ","work":"Careers","news":"News","contact":"Contact"},"buyOnline":"Order online"}}}')
  delete Component.options._Ctor
}
